/**
 * Fetch through exactly one production credential channel.
 *
 * Cookie-mode transports carry `credentials: "include"`. Their factories give
 * them an empty bearer, and this seam removes the resulting empty header so the
 * coordinator can authenticate the WorkOS cookie. Auth-stub builds still pass a
 * real token and retain the header.
 */
export function credentialFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const entries: Array<[string, string]> = [];
  if (init.headers instanceof Headers) {
    init.headers.forEach((value, key) => entries.push([key, value]));
  } else if (Array.isArray(init.headers)) {
    entries.push(...init.headers.map(([key, value]) => [key, value] as [string, string]));
  } else {
    entries.push(...Object.entries(init.headers ?? {}));
  }
  const headers = Object.fromEntries(entries);
  const emptyAuthorization = Object.keys(headers).find(
    (key) => key.toLowerCase() === "authorization" && headers[key].trim().toLowerCase() === "bearer",
  );
  if (emptyAuthorization) delete headers[emptyAuthorization];
  return globalThis.fetch(input, { ...init, headers });
}
